export function getDefaultActiveLocation(locations, defaultActiveLocationId) {
  const locationMatches = locations.filter(({ _id }) => _id === defaultActiveLocationId);

  if (locationMatches.length) {
    return locationMatches[0];
  }

  return {};
}

export function formatLocations(locations = []) {
  return locations.map(({ _id, ...rest }) => ({
    id: _id,
    ...rest,
  }));
}
